import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PlatformEnum } from '@panamax/app-state';
@Component({
  selector: 'app-sort-and-filter-button',
  templateUrl: './sort-and-filter-button.component.html',
  styleUrls: ['./sort-and-filter-button.component.scss'],
})
export class SortAndFilterButtonComponent {
  @Input() sortAndFilterCount: number;
  @Input() sortAndFilterText = 'i18n.lists.sortAndFilter';
  @Input() onRecentPurchase = false;
  @Input() showAddButton = false;
  @Input() isSelected = false;
  @Input() disabled = false;
  @Input() platformType: PlatformEnum;
  @Input() showClearAll = true;
  @Input() buttonFullWidth = false;
  @Output()
  openSortAndFilterListModalEmitter: EventEmitter<void> = new EventEmitter();
  @Output()
  clearSortAndFilterListModalEmitter: EventEmitter<void> = new EventEmitter();
  @Output()
  addToListEmitter: EventEmitter<void> = new EventEmitter();
  @Output()
  addProductsEmitter: EventEmitter<void> = new EventEmitter();
  platformEnum = PlatformEnum;
  constructor() {}

  openSortAndFilterListModal() {
    this.openSortAndFilterListModalEmitter.emit();
  }

  clearSortAndFilter() {
    if (!this.disabled) {
      this.clearSortAndFilterListModalEmitter.emit();
    }
  }

  addtoList() {
    this.addToListEmitter.emit();
  }

  onAddProductClick() {
    this.addProductsEmitter.emit();
  }
}
